import { InfoOutlined } from "@mui/icons-material";
import { FormControl, Tooltip, MenuItem } from "@mui/material";
import { AppSelect } from "components/common/Input";
import { GetFieldPropsType, Label } from "./SelectBox";

const InsuranceComponent = ({ fullWidth, getFieldProps }: { fullWidth: boolean; getFieldProps: GetFieldPropsType }) => (
  <FormControl variant="standard" sx={{ gridColumn: fullWidth ? "span 2" : "span 1" }}>
    <Label sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      Insurance
      <Tooltip title="UPS provides liability coverage for shipments up to $100. Purchase additional coverage below.">
        <InfoOutlined color="primary" sx={{ fontSize: "15px" }} />
      </Tooltip>
    </Label>
    <AppSelect {...getFieldProps<string>("insuranceOption")} placeholder="Select Insurance">
      <MenuItem value="0">No Insurance</MenuItem>
      <MenuItem value="10">Up to $1,000 (+$10)</MenuItem>
      <MenuItem value="20">Up to $2,000 (+$20)</MenuItem>
      <MenuItem value="30">Up to $3,000 (+$30)</MenuItem>
      <MenuItem value="40">Up to $4,000 (+$40)</MenuItem>
      <MenuItem value="50">Up to $5,000 (+$50)</MenuItem>
    </AppSelect>
  </FormControl>
);

export default InsuranceComponent;
